import React, { useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import "./Sidebar_list.css";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const categories = [
  "All Categories",
  "Calendars & Diaries",
  "Apparels",
  "Photo Gifts",
  "Rewards & Recognition",
  "Business Stationery",
  "Corporate Gifts",
  "Packaging",
  "Marketing & Promo",
  "Premium Products",
  "Gift Hampers",
  "Sample Kit",
];

function Sidebar_list({category}) {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <section className="Sidebar_list">
        <Card className="sidebar-card">
          <ListGroup variant="flush">
            {category.map((item, index) => (
              <ListGroup.Item
                key={index}
                className={`sidebar-item ${
                  activeIndex === index ? "active" : ""
                }`}
                onClick={() => setActiveIndex(index)}
              >
                {item?.name}
                <span>
                  {" "}
                  <FontAwesomeIcon icon={faAngleRight} />
                </span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      </section>
    </>
  );
}

export default Sidebar_list;
